import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';

import { Select } from 'core/components/select';
import useSession from 'core/hooks/use-session';
import { Collapsible } from '../collapsible';

const simulateSourceOptions = [
  { id: '', value: 'None (default Staff behavior)' },
  { id: 'apiRC1', value: 'API (RC1)' },
  { id: 'apiRC3', value: 'API (RC3)' }
];

const ScenarioSimulationTools = ({ simulateSource, onChange }) => {
  const { canSimulateSource } = useSession();

  if (!canSimulateSource) {
    return null;
  }

  return (
    <Collapsible initialOpen={false} title="Scenario Simulation Tools">
      <Grid item xs={4}>
        <Select
          id="simulateSource"
          name="simulateSource"
          label="Simulate Source"
          mode="light"
          value={simulateSource || ''}
          options={simulateSourceOptions}
          onChange={(_name, value) => onChange(value)}
          fullWidth
        />
      </Grid>
    </Collapsible>
  );
};

ScenarioSimulationTools.propTypes = {
  simulateSource: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

export default ScenarioSimulationTools;
